import { useInfiniteQuery, useMutation } from 'react-query';

import { useServiceError } from '@/hooks';

import { PageRequest } from '@/core/request/PageRequest';

import { DEFAULT_ORDER, DEFAULT_ROWS } from '..';
import notificationError from '@/utils/functions/notificationError';
import { notification } from 'antd';
import { SaleTagsQueryFilter } from './SaleTags.types';
import {
  createSaleTag,
  deleteSaleTag,
  listSaleTags,
  updateSaleTag,
} from './SaleTags.service';
import { useQueryChanel } from '@/contexts/QueryChanelProvider';

export const SALE_TAGS_LIST = 'sale-tags';

export function useSalesTags(params?: SaleTagsQueryFilter, enabled?: boolean) {
  const query = useInfiniteQuery(
    [SALE_TAGS_LIST, { ...params }],
    ({ pageParam }) => {
      const req: PageRequest = {
        nextToken: pageParam,
        order: params?.order || DEFAULT_ORDER,
        rows: params?.rows || DEFAULT_ROWS,
        ...params,
      };

      return listSaleTags(req);
    },
    {
      enabled: enabled,
      getNextPageParam: (lastPage) => lastPage.nextToken,
    },
  );

  useServiceError(query.error);

  return query;
}

export function useCreateSaleTag() {
  const queryChanel = useQueryChanel();

  const mutation = useMutation(createSaleTag, {
    async onSuccess() {
      notification.success({
        message: 'Sucesso',
        description: 'Etiqueta criada com sucesso',
      });

      queryChanel({
        invalidateQueries: [SALE_TAGS_LIST],
        refetchQueries: [SALE_TAGS_LIST],
      });
    },
    onError(error) {
      notificationError(error);
    },
  });

  return mutation;
}

export function useUpdateSaleTag() {
  const queryChanel = useQueryChanel();

  const mutation = useMutation(updateSaleTag, {
    async onSuccess() {
      notification.success({
        message: 'Sucesso',
        description: 'Etiqueta editada com sucesso',
      });

      queryChanel({
        invalidateQueries: [SALE_TAGS_LIST],
        refetchQueries: [SALE_TAGS_LIST],
      });
    },
    onError(error) {
      notificationError(error);
    },
  });

  return mutation;
}

export function useDeleteSaleTag() {
  const queryChanel = useQueryChanel();

  const mutation = useMutation(deleteSaleTag, {
    async onSuccess() {
      notification.success({
        message: 'Sucesso',
        description: 'Etiqueta excluida com sucesso',
      });

      queryChanel({
        invalidateQueries: [SALE_TAGS_LIST],
        refetchQueries: [SALE_TAGS_LIST],
      });
    },

    onError(error) {
      notificationError(error);
    },
  });

  return mutation;
}
